import { toast, Bounce } from 'react-toastify';

export const NotificationKeys = {
	HAND_RAISED_AUDIO_OFF: 'hand_raised_audio_off',
	HAND_RAISED_POPUP_OFF: 'hand_raised_popup_off',
	MESSAGES_AUDIO_OFF: 'messages_audio_off',
	MESSAGES_POPUP_OFF: 'messages_popup_off',
	JOIN_CLASS_AUDIO_OFF: 'join_class_audio_off',
	JOIN_CLASS_POPUP_OFF: 'join_class_popup_off',
};

const playNotification = (url: string) => {
	const audioContext = new (window.AudioContext || window.webkitAudioContext)();

	// Load and play the audio file
	fetch(url)
		.then((response) => response.arrayBuffer())
		.then((buffer) => {
			audioContext.decodeAudioData(buffer, (decodedData) => {
				const source = audioContext.createBufferSource();
				source.buffer = decodedData;
				source.connect(audioContext.destination);
				source.start();
			});
		})
		.catch((error) => {
			console.error('Failed to load audio:', error);
		});
};

export const playNotificationHandRaised = () => {
	if (!localStorage.getItem(NotificationKeys.HAND_RAISED_AUDIO_OFF)) {
		playNotification('/notifications-sounds/hand-raised-notification.wav');
	}
};

export const showToastNotificationHandRaised = ({name}: {name?: string}) => {
	if (!localStorage.getItem(NotificationKeys.HAND_RAISED_POPUP_OFF)) {
		toast(`✋ ${name || 'Someone'} raised their hand`, {
			toastId: 'hand-raised',
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "light",
			transition: Bounce,
		});
	}
};

export const playNotificationNewMessage = () => {
	if (!localStorage.getItem(NotificationKeys.MESSAGES_AUDIO_OFF)) {
		playNotification('/notifications-sounds/new-message-notification.wav');
	}
};

export const showToastNotificationNewMessage = ({name, message}: {name?: string, message?: string}) => {
	if (!localStorage.getItem(NotificationKeys.MESSAGES_POPUP_OFF)) {
		const truncatedMessage = message && message.length > 100 ? `${message.substring(0, 100)}...` : message;
		toast(`💬 ${name || 'Someone'}: ${truncatedMessage}`, {
			toastId: 'new-message',
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "light",
			transition: Bounce,
		});
	}
};

export const playNotificationStudentInLobby = () => {
	if (!localStorage.getItem(NotificationKeys.JOIN_CLASS_AUDIO_OFF)) {
		playNotification('/notifications-sounds/student-in-lobby.wav');
	}
};

export const showToastNotificationStudentInLobby = ({name}: {name?: string}) => {
	if (!localStorage.getItem(NotificationKeys.JOIN_CLASS_POPUP_OFF)) {
		toast(`🚪 ${name || 'Someone'} joined the class`, {
			toastId: 'student-lobby',
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "light",
				transition: Bounce,
		});
	}
};

export const playNotificationInactivityLogout = () => {
	playNotification('/notifications-sounds/logout-sound.wav');
};


